import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../App';

let cache = null;

export const clearMyAccessCache = () => { cache = null; };

// iter 1006 - role/permission awareness for the UI.
// Fail-open: while loading or on error we grant everything (backend still
// enforces); once loaded, members are gated by their stored permissions.
export function useMyAccess() {
  const [access, setAccess] = useState(cache);

  useEffect(() => {
    if (cache) { setAccess(cache); return; }
    let mounted = true;
    axios.get(`${API}/business/access/my-access`)
      .then((r) => { cache = r.data; if (mounted) setAccess(r.data); })
      .catch(() => {
        cache = { role: 'owner', is_owner: true, permissions: null };
        if (mounted) setAccess(cache);
      });
    return () => { mounted = false; };
  }, []);

  const isMember = !!(access && access.role && !access.is_owner);
  const hasPermission = (perm) => {
    if (!access || access.is_owner || access.permissions === null) return true;
    if (!access.role) return true; // personal accounts / no business context
    return (access.permissions || []).includes(perm);
  };

  return { access, isMember, hasPermission, role: access?.role || null };
}
